/* tslint:disable */
/* eslint-disable */
/**
 * Wire API (development)
 * The API for the Clientwire messaging service.
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: support@clientwire.net
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { MessageTemplateParameter } from './message-template-parameter';
import {
    MessageTemplateParameterFromJSON,
    MessageTemplateParameterFromJSONTyped,
    MessageTemplateParameterToJSON,
    MessageTemplateParameterToJSONTyped,
} from './message-template-parameter';

/**
 * 
 * @export
 * @interface MessageTemplateLight
 */
export interface MessageTemplateLight {
    /**
     * 
     * @type {string}
     * @memberof MessageTemplateLight
     */
    name: string;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof MessageTemplateLight
     */
    texts: { [key: string]: string; };
    /**
     * 
     * @type {Array<MessageTemplateParameter>}
     * @memberof MessageTemplateLight
     */
    parameters: Array<MessageTemplateParameter>;
}

/**
 * Check if a given object implements the MessageTemplateLight interface.
 */
export function instanceOfMessageTemplateLight(value: object): value is MessageTemplateLight {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('texts' in value) || value['texts'] === undefined) return false;
    if (!('parameters' in value) || value['parameters'] === undefined) return false;
    return true;
}

export function MessageTemplateLightFromJSON(json: any): MessageTemplateLight {
    return MessageTemplateLightFromJSONTyped(json, false);
}

export function MessageTemplateLightFromJSONTyped(json: any, ignoreDiscriminator: boolean): MessageTemplateLight {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'texts': json['texts'],
        'parameters': ((json['parameters'] as Array<any>).map(MessageTemplateParameterFromJSON)),
    };
}

export function MessageTemplateLightToJSON(json: any): MessageTemplateLight {
    return MessageTemplateLightToJSONTyped(json, false);
}

export function MessageTemplateLightToJSONTyped(value?: MessageTemplateLight | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'texts': value['texts'],
        'parameters': ((value['parameters'] as Array<any>).map(MessageTemplateParameterToJSON)),
    };
}

